import { Table, TableBody, TableHead, TableHeader, TableRow, TableCell } from "@/components/ui/table";
import LostFoundTableRow from "@/components/lost-found/LostFoundTableRow";
import LostFoundGridCard from "@/components/lost-found/LostFoundGridCard";
import { LostItem } from "@/types";
import React from "react";

interface LostFoundViewSwitcherProps {
  view: "list" | "grid";
  items: LostItem[];
  handlers: {
    onDeliver: (item: LostItem) => void;
    onUndo: (item: LostItem) => void;
    onEdit: (item: LostItem) => void;
    onDelete: (item: LostItem) => void;
    onDiscard: (item: LostItem) => void;
    openTimeline: (item: LostItem) => void;
    openInfo: (item: LostItem) => void;
  };
  setSelectedItem: (item: LostItem) => void;
  setDeleteDialogOpen: (open: boolean) => void;
}

const LostFoundViewSwitcher: React.FC<LostFoundViewSwitcherProps> = ({
  view,
  items,
  handlers,
  setSelectedItem,
  setDeleteDialogOpen
}) => {
  // Sort items by date in descending order (newest first)
  const sortedItems = [...items].sort((a, b) => 
    new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  if (view === "list") {
    return (
      <div className="rounded-md border overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-24">Sequential</TableHead>
              <TableHead className="w-64 max-w-xs">Description</TableHead>
              <TableHead className="w-32">Location</TableHead>
              <TableHead className="w-32">Date</TableHead>
              <TableHead className="w-24">Status</TableHead>
              <TableHead className="w-24">Photo</TableHead>
              <TableHead className="w-32">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sortedItems.map((item) => (
              <LostFoundTableRow key={item.id} item={item} {...handlers} setSelectedItem={setSelectedItem} setDeleteDialogOpen={setDeleteDialogOpen} />
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
  // grid
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {sortedItems.map((item) => (
        <LostFoundGridCard key={item.id} item={item} {...handlers} setSelectedItem={setSelectedItem} setDeleteDialogOpen={setDeleteDialogOpen} />
      ))}
    </div>
  );
};

export default LostFoundViewSwitcher;
